import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import querystring from 'querystring';
/**
 * Tests if a given object has a value other than null or undefined
 * @param {any} obj - Any JavaScript object
 */

var hasValue = function hasValue(obj) {
  return typeof obj !== 'undefined' && obj !== null;
};
/**
 * Takes an object and returns an object with only properties that have values other than null
 * or undefined
 * @param {object} obj - A JavaScript object
 */


var compact = function compact(obj) {
  return Object.keys(obj).filter(function (k) {
    return hasValue(obj[k]);
  }).reduce(function (newObj, k) {
    return _objectSpread({}, newObj, _defineProperty({}, k, obj[k]));
  }, {});
};

export default function toQueryString(obj) {
  return querystring.stringify(compact(obj));
}